import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="announcement"
export default class extends Controller {
  static values = { dismissUrl: String };

  dismiss() {
    // Close the modal if this announcement is in a modal
    const turboFrame = document.querySelector('turbo-frame#modal');
    if (turboFrame) {
      const modalElement = turboFrame.querySelector('[data-controller~="modal"]');
      if (modalElement) {
        console.log("Found modal element, hiding modal");
        const modalController = this.application.getControllerForElementAndIdentifier(modalElement, "modal");
        if (modalController) {
          modalController.hideModal();
        }
      }
    }

    this.element.remove();

    if (!this.hasDismissUrlValue) return;

    fetch(this.dismissUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "application/json",
      },
    });
  }
}
